<template>
  <slice
    :id="block._key"
    class="block--impact-fairly container"
    @in="$emit('in')"
    @out="$emit('out')"
  >
    <h2>
      {{ $t('product.impact.title') }}
    </h2>
    <div
      v-if="block.list && block.list.length > 0"
      class="block__inner"
      :class="{
        'block__inner--4-elements': block.list.length === 4,
      }"
      :style="{
        '--number-of-elements': block.list.length,
      }"
    >
      <div v-for="el of block.list" :key="el._key" class="block__child">
        <p class="d-flex align-baseline">
          <number-animated
            ref="number"
            :from="0"
            :to="el.value"
            :duration="1"
            animation-paused
            class="block__value text-secondary"
          />
          <span class="block__unit">{{ el.unit }}</span>
        </p>

        <p v-if="el.description" class="block__text text-small">
          {{ el.description }}
        </p>
      </div>
    </div>

    <div class="pb-2">
      <button-link
        v-if="block.fairly_link"
        with-icon
        icon="fingerprint"
        no-underline
        @click="showModal = true"
      >
        <span class="text-small">{{ $t('product.traca.know_all') }}</span>
      </button-link>
    </div>

    <purchase-modal
      :show="showModal"
      :title="$t('product.traca.title')"
      full-page
      desktop-override-purchase
      @hide="showModal = false"
    >
      <template #content>
        <div v-if="showModal" class="h-100">
          <iframe
            :src="`${block.fairly_link}?lang=${$i18n.locale.slice(0, 2)}`"
            class="w-100"
            style="height: 100%; border: none"
          />
        </div>
      </template>
    </purchase-modal>
  </slice>
</template>

<script>
import Slice from '@/components/Slices/Slice'
import ButtonLink from '@/components/buttons/Link'
import PurchaseModal from '@/components/modal/PurchaseModal'

export default {
  title: 'BlockImpactFairly',
  components: {
    Slice,
    ButtonLink,
    PurchaseModal,
    NumberAnimated: () => ({
      component: import(
        '@/components/number/Number' /* webpackChunkName: 'animated_number' */
      ),
    }),
  },
  props: {
    block: { type: Object, required: true },
  },
  data: () => ({
    showModal: false,
  }),
}
</script>

<style lang="scss">
.block--impact-fairly {
  @include mq($from: tablet) {
    padding: 0 calc(var(--spacing) * 3) calc(var(--spacing) * 4);
  }

  .block__inner {
    --number-of-elements: 3;

    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--spacing);
    padding: calc(var(--spacing) * 3) 0 calc(var(--spacing) * 2);

    @include mq($from: tablet) {
      padding: calc(var(--spacing) * 4) 0 calc(var(--spacing) * 3);
      grid-template-columns: repeat(
        #{'min(var(--number-of-elements), 3)'},
        1fr
      );
    }

    &--4-elements {
      @include mq($from: tablet) {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }

  .block__value {
    font-size: rem(56px);
    line-height: rem(34px);
  }

  .block__unit {
    font-size: rem(24px);
    line-height: rem(34px);
  }

  .block__text {
    margin-top: calc(var(--spacing) * 0.6);
    padding-top: calc(var(--spacing) * 0.6);
    border-top: 1px solid RGB(0 46 93 / 0.4);
  }

  .btn-link {
    text-decoration: underline;
    gap: calc(var(--spacing) * 0.2);
  }
}
</style>
